var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92128 13.3349H16.5683M12.7448 9.51137V17.1584M26.7644 27.3545L19.1174 19.7074M3.82324 13.3349C3.82324 14.5065 4.05401 15.6666 4.50236 16.749C4.95071 17.8315 5.60786 18.815 6.43631 19.6434C7.26475 20.4718 8.24826 21.129 9.33067 21.5774C10.4131 22.0257 11.5732 22.2565 12.7448 22.2565C13.9164 22.2565 15.0765 22.0257 16.1589 21.5774C17.2414 21.129 18.2249 20.4718 19.0533 19.6434C19.8818 18.815 20.5389 17.8315 20.9873 16.749C21.4356 15.6666 21.6664 14.5065 21.6664 13.3349C21.6664 12.1633 21.4356 11.0032 20.9873 9.92076C20.5389 8.83835 19.8818 7.85484 19.0533 7.0264C18.2249 6.19795 17.2414 5.54079 16.1589 5.09244C15.0765 4.64409 13.9164 4.41333 12.7448 4.41333C11.5732 4.41333 10.4131 4.64409 9.33067 5.09244C8.24826 5.54079 7.26475 6.19795 6.43631 7.0264C5.60786 7.85484 4.95071 8.83835 4.50236 9.92076C4.05401 11.0032 3.82324 12.1633 3.82324 13.3349Z",
    stroke: "#7C7C7C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/zoomIcon.af8f5fce98553a02fd22907e84452e01.svg";
export { ForwardRef as ReactComponent };